import React, { useEffect, useRef } from 'react';
import { motion, useInView, useMotionValue, useSpring } from 'framer-motion';
function AnimatedNumber({
  value
}: {
  value: number;
}) {
  const ref = useRef<HTMLSpanElement>(null);
  const motionValue = useMotionValue(0);
  const springValue = useSpring(motionValue, {
    duration: 2000,
    bounce: 0
  });
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  useEffect(() => {
    if (isInView) {
      motionValue.set(value);
    }
  }, [isInView, motionValue, value]);
  useEffect(() => {
    return springValue.on('change', latest => {
      if (ref.current) {
        ref.current.textContent = Intl.NumberFormat('en-US').format(Math.floor(latest));
      }
    });
  }, [springValue]);
  return <span ref={ref} data-id="element-226">0</span>;
}
const stats = [{
  value: 100,
  label: 'Aplicaciones y ejemplos',
  prefix: '+'
}, {
  value: 40,
  label: 'Proyectos y estructuras',
  prefix: '+'
}, {
  value: 25,
  label: 'Errores evitados',
  prefix: '+'
}, {
  value: 6,
  label: 'Bonus incluidos',
  prefix: '+'
}];
export function Stats() {
  return <section className="py-24 relative overflow-hidden" data-id="element-227">
      <div className="absolute inset-0 bg-[#C0C0C0]/5" data-id="element-228" />

      <div className="container mx-auto px-6 relative z-10" data-id="element-229">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-230">
          <h2 className="text-4xl md:text-5xl font-bold font-heading mb-6" data-id="element-231">
            Resultados que podés obtener
          </h2>
        </motion.div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-232">
          {stats.map((stat, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} className="glass-panel rounded-3xl p-8 text-center flex flex-col items-center justify-center relative overflow-hidden group" data-id="element-233">
              <div className="absolute inset-0 bg-gradient-to-b from-white/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-234" />

              <div className="text-5xl md:text-6xl font-bold font-heading mb-4 metallic-text flex items-center" data-id="element-235">
                {stat.prefix}
                <AnimatedNumber value={stat.value} data-id="element-236" />
              </div>
              <p className="text-gray-400 font-medium max-w-[150px]" data-id="element-237">
                {stat.label}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}